exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.multiselect[data-v-6d6e8858] {\nposition: absolute;\nmargin-top: 30px;\nleft: 0px;\n}\n.status-field .multiselect__content-wrapper[data-v-6d6e8858] {\n\tmin-height:40px;\n}\n\n", ""]);

// exports
